import styled from "styled-components";

export const Container = styled.div``;

// The stars keep their own color, as on the published page
const STAR_COLOR = "#FFC107";

/* The stars and the photo: titled like the labels of the fields (LabelText), all in the editor's font */
export const Field = styled.div`
  margin-bottom: 24px;
  font-family: "Inter", sans-serif;

  .caption {
    margin-bottom: 12px;
  }
`;

export const Stars = styled.div`
  display: flex;
  gap: 4px;

  button {
    display: grid;
    place-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: none;
    color: var(--color-neutral-base);
    cursor: pointer;
  }

  button.on {
    color: ${STAR_COLOR};
  }

  button:focus-visible {
    outline: 2px solid var(--color-neutral-white);
  }
`;
